var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCisa(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 465.74,
    height: 466.54,
    viewBox: "0 0 465.73919 466.54269",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m72 660.3h59.6v59.701h-59.6z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.3333 0 0 -1.3333 97.411 1153.7)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(6 0 0 6 -507.97 -3451.8)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.010781 0 0 -.0108 72 720)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(5445,2745)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c0 1491-1209 2700-2700 2700s-2700-1209-2700-2700 1209-2700 2700-2700 2700 1209 2700 2700",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.010781 0 0 -.0108 72 720)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2745,110)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-1453 0-2635 1182-2635 2635s1182 2635 2635 2635 2635-1182 2635-2635-1182-2635-2635-2635m0 5114c-1367 0-2479-1112-2479-2479s1112-2479 2479-2479 2479 1112 2479 2479-1112 2479-2479 2479",
    fill: "#005288"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.010781 0 0 -.0108 72 720)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2893,3725)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c84-16 173-27 261-30v21c-215 10-375 69-481 126-15-15-29-31-43-46 74-27 165-52 263-71m-206 131c36 37 73 73 113 107v-71c0-38 26-69 58-69 33 0 59 31 59 69v163c18 14 36 26 55 39v-253c0-38 26-69 58-69s59 31 59 69v324c21 13 43 24 65 35v-466c-208 10-363 68-467 122m147-401 39 19 21-12-53-31zm22-82 42-33-27-21zm22-79 39 31 39-30-39-149zm84 180v-25l-21 13zm-63 12 63 31v-16l-45-26zm65-167-27 21 41 33zm-47 129 68-39-67-54-68 54zm66-11 6 3 8 4-3-13zm-44-2033-59 33-32 45c-18-8-66-29-110-45-45-17-106-36-106-36 114 1 141 1 146 1h1c5 1 34 1 160 2m1601 1341c0 991-804 1794-1795 1794-207 0-407-35-592-99 0 0 346-277 493-426-102-96-194-204-274-322-63-93-117-191-162-292l-860 859 29-350c-267-313-428-720-428-1164 0-991 803-1794 1794-1794s1795 803 1795 1794m-2694-1457 400 215-231 237 170-7-140 233h9c105 0 203 34 283 92 184-29 447-64 695-79-1-2-2-3-3-5-3-7-7-14-11-22-5-11-11-22-17-33-7-15-15-30-22-45-9-17-18-35-27-52-9-20-19-40-29-60 0 0 43-59 126-84 77-24 162-1 212 66 16 21 28 45 28 70 0 0 132-198 100-311-32-114-284-102-284-102h-84l-76-80c-20-21-48-34-77-34h-1022zm-330 1679 203-215v-214l-183 193zm621-287c97-35 162-128 162-231v-9c-33-5-59-27-70-57h-157c-6 15-15 28-26 38-15 12-35 20-56 20-37 0-69-24-82-58h-43l-87 93v300l-270 286-23 270 272-287c-6-12-9-25-9-39 0-48 39-87 87-87s87 39 87 87-39 87-87 87c-13 0-24-3-35-8l-323 342-23 270 303-320c-6-12-9-25-9-39 0-48 39-87 87-87s87 39 87 87-39 87-87 87c-12 0-24-3-35-8l-354 377-27 312 698-697v-722zm-302 685c15 0 27-12 27-27s-12-28-27-28c-16 0-28 13-28 28s12 27 28 27m0-332c15 0 27-12 27-27 0-16-12-28-27-28-16 0-28 12-28 28 0 15 12 27 28 27m155-652c15 0 28-12 28-27 0-16-13-28-28-28s-27 12-27 28c0 15 12 27 27 27m320 0c15 0 28-12 28-27 0-16-13-28-28-28s-27 12-27 28c0 15 12 27 27 27m19 816v-421c93-79 152-196 152-327 0-133-60-252-156-330-22-18-46-34-72-48-59-31-127-49-199-49-152 0-285 79-361 198v1c-6 9-133 228-133 228l-16 187 296-312h68c12-33 44-57 82-57 21 0 40 7 55 20 12 10 21 22 27 37h157c12-33 44-57 81-57 48 0 87 39 87 87 0 30-16 57-40 73 1 7 2 15 2 22 0 121-73 231-182 279v622zm2039-574v-467s-489-126-1095-126h-38c-272 2-605 44-839 78 87 88 141 208 141 341 0 134-55 261-152 352v15h1889c-27 251-107 490-232 702v-51h-154v-78h-86v-91h-52v-55c0-8-2-15-7-22-8-12-21-19-35-19s-27 7-35 19c-4 7-6 14-6 22v55h-52v90h-63v-295h-398v428l-120-59c-33-111-66-220-97-330 9-6 15-16 15-28 0-20-16-35-35-35s-35 15-35 35c0 12 6 22 15 28-30 103-60 206-91 309l-2-1-27-13v103h-46l-21-352-1-18h-141l-1 18-21 352h-109c-46-76-86-156-119-238l-63 63c188 438 541 789 981 975 665-281 1132-940 1132-1707",
    fill: "#005288"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.010781 0 0 -.0108 72 720)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(593,2862)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0-2-68c37-1 67 9 92 27 24 19 38 45 40 79 4 41-9 74-38 98s-70 38-123 42c-54 5-98-3-130-22s-50-49-53-91c-6-70 34-111 120-124l10 66c-49 6-73 24-70 53 1 15 10 27 26 34 17 8 49 10 95 7 41-4 69-10 83-20 15-9 22-22 21-39-3-27-26-41-71-42",
    fill: "#005288"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.010781 0 0 -.0108 72 720)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(374,2785)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0 3-81 124-43-121-55 3-72 190 100 142 5-3 73-142-5z",
    fill: "#005288"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.010781 0 0 -.0108 72 720)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(388,2487)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0 18-113c4-27 9-47 16-60 6-12 17-22 33-29 15-7 34-9 55-6 37 6 58 26 64 59 19-36 49-50 90-44 21 3 39 11 52 24 13 12 21 26 24 42 2 16 2 38-3 65l-17 113zm145-49 4-24c3-23 1-39-6-46-8-7-17-12-28-14-10-1-19 0-28 5s-15 17-18 37l-4 29zm141 22 5-36c6-34-6-53-35-57-16-3-28 0-36 7s-13 20-16 36l-5 36z",
    fill: "#005288"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.010781 0 0 -.0108 72 720)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(444,2178)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0 56-196 55 15-36 125 75 22 28-97 55 15-27 98 79 22 36-125 57 17-56 196z",
    fill: "#005288"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.010781 0 0 -.0108 72 720)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(523,1919)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0 41-97c8-19 15-33 21-42 6-10 15-18 27-25s25-11 41-11 32 3 48 10c39 17 60 43 63 78l159 1-31 73-140-10-14 34 122 52-29 67zm78-47 87 37 13-30c11-27 2-46-28-59-10-4-19-6-28-4-8 1-14 4-19 8-4 4-9 11-13 21z",
    fill: "#005288"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.010781 0 0 -.0108 72 720)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(814,1499)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0-10 65c-29-7-49 0-60 20-6 9-7 18-5 27 2 8 7 15 14 19 8 5 16 5 25 2 9-4 23-14 43-30 17-14 33-25 46-32s27-10 43-10c15 1 31 5 46 14 27 16 44 38 50 67 7 29 1 58-17 90-31 52-77 70-138 54l16-65c33 10 57 3 71-21 6-11 9-22 7-32s-7-18-17-23c-7-4-14-6-23-4-8 1-21 9-37 23-21 17-38 30-50 37-13 7-28 11-44 11s-31-4-47-13c-26-15-42-36-49-63-7-26-2-53 14-81 29-50 70-69 122-55",
    fill: "#005288"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.010781 0 0 -.0108 72 720)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(797,1395)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0 123-163 45 35-78 104 63 47 60-81 46 34-60 81 66 50 78-105 48 36-123 163z",
    fill: "#005288"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.010781 0 0 -.0108 72 720)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1230,1212)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0 50-47c25 27 38 56 40 87 3 31-8 58-32 83-28 29-61 41-98 36-37-6-75-27-114-64-39-38-62-75-69-112-8-36 4-70 33-100 48-51 106-48 172 7l-43 52c-37-33-65-39-86-18-10 11-13 26-8 43 5 18 25 43 58 75 30 28 53 45 70 50 17 4 31 1 43-11 18-20 13-47-16-81",
    fill: "#005288"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.010781 0 0 -.0108 72 720)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1181,964)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0 57-46 120 149c17 22 29 36 38 42 8 7 17 10 27 10 9-1 19-5 27-12 10-7 16-16 18-25 1-9 0-18-5-27s-16-24-33-45l-119-150 48-38 118 147c23 30 39 53 47 70s9 36 4 58c-6 21-21 42-45 61-23 18-44 29-63 32-19 2-37-1-53-10-17-10-39-32-67-67z",
    fill: "#005288"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.010781 0 0 -.0108 72 720)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1439,767)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0 90-54c18-11 32-18 42-22s22-5 36-4 27 7 40 16 24 21 33 36c21 36 23 69 5 100l128 94-69 41-106-90-32 19 68 113-63 38zm91 8 48 81 28-17c25-14 29-36 12-63-5-10-12-17-19-21-8-3-14-5-20-4-7 0-14 4-24 9z",
    fill: "#005288"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.010781 0 0 -.0108 72 720)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1699,620)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0 67-32 143 303-67 32z",
    fill: "#005288"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.010781 0 0 -.0108 72 720)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1806,568)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0 196-74 22 58-64 25 97 254-69 26l-97-254-62 24z",
    fill: "#005288"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.010781 0 0 -.0108 72 720)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2037,481)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0 79-20 76 107 18-131 70-18-42 211 35 137-72 18-35-137z",
    fill: "#005288"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.010781 0 0 -.0108 72 720)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2669,520)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0 55 6c-6 40-18 77-37 110 12 11 24 16 35 16 2-1 5-1 12-2l4 57c-9 3-18 5-25 5-24 2-46-7-68-26-25 24-55 37-88 40-37 3-65-5-83-24-19-18-29-41-31-67-3-43 20-77 69-102-23-27-36-51-37-73-2-20 5-38 20-54 16-16 36-25 62-27 27-2 48 4 65 18 16 15 25 33 27 55 3 34-15 62-52 85l51 58c10-18 16-43 21-75m-127 50c-21 15-31 34-30 56 1 14 7 25 16 33 9 9 21 12 36 11 18-1 33-9 45-23zm24-69c19-12 28-29 27-48-1-8-4-14-8-20-5-5-12-7-20-6-9 0-15 3-19 8-4 6-6 12-6 20 1 12 10 27 26 46",
    fill: "#005288"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.010781 0 0 -.0108 72 720)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2891,381)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0 73 6-25 334-74-5z",
    fill: "#005288"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.010781 0 0 -.0108 72 720)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3049,394)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0 81 14 48 220 37-205 56 10-59 330-65-11-58-257-42 239-56-10z",
    fill: "#005288"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.010781 0 0 -.0108 72 720)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3358,456)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0 191 58-17 55-120-36-25 83 92 29-17 55-92-29-39 127-70-21z",
    fill: "#005288"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.010781 0 0 -.0108 72 720)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3599,533)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0 96 43c19 8 33 15 42 21s17 15 24 28c7 12 11 25 11 41s-4 32-11 48c-17 38-43 59-79 62l-2 159-74-32 13-140-34-14-53 121-68-30zm45 80-37 86 29 13c27 12 46 3 59-27 5-10 6-19 5-28-1-8-3-14-7-19-4-4-12-9-22-13z",
    fill: "#005288"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.010781 0 0 -.0108 72 720)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3963,714)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0 63 39-96 336-64-40 23-68-80-50-51 50-58-36zm-56 211 44-135-100 100z",
    fill: "#005288"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.010781 0 0 -.0108 72 720)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4268,1026)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0-62-20c11-27 7-48-11-63-8-6-17-9-25-9-9 1-16 5-21 11-6 7-8 16-6 25 3 9 10 24 23 46 12 20 20 37 25 51 4 14 5 28 3 44-3 15-10 30-21 43-19 25-44 38-73 40-30 2-58-8-87-31-47-38-58-86-32-145l61 26c-15 32-11 56 10 74 10 8 21 11 31 11s19-4 26-13c5-6 7-13 7-22 0-8-6-22-17-40-14-23-24-42-29-55-5-14-7-29-5-45 3-16 9-31 20-44 19-24 43-37 70-40 27-2 53 6 78 26 45 37 57 80 35 130",
    fill: "#005288"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.010781 0 0 -.0108 72 720)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4354,1005)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0 147 149-45 44-48-49-194 192-52-53 194-191-47-48z",
    fill: "#005288"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.010781 0 0 -.0108 72 720)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4537,1194)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0 65 82c13 16 22 29 27 39s8 22 9 35c0 14-3 28-11 42-7 14-18 26-32 37-33 26-66 32-98 18l-77 140-50-63 76-118-23-29-104 83-45-58zm3 91-74 59 20 25c18 23 40 24 65 4 9-7 15-14 17-22 3-8 4-15 3-21-2-6-6-13-13-22z",
    fill: "#005288"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.010781 0 0 -.0108 72 720)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4721,1436)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0 38 63-165 98c-23 14-39 25-46 32-8 8-13 16-13 26-1 9 1 19 7 29 7 10 14 17 23 20s18 3 28-1c9-4 25-12 49-26l164-98 32 53-162 96c-33 19-58 32-76 38-18 5-37 4-58-5-20-8-38-25-54-52-15-25-23-48-23-67s6-36 17-51c12-15 36-34 75-57z",
    fill: "#005288"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.010781 0 0 -.0108 72 720)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4749,1952)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0 23 64c-34 12-66 13-95 3s-50-30-64-61c-16-38-14-73 6-105 19-32 54-58 103-80 50-21 93-28 130-20s63 31 80 70c27 64 2 116-75 156l-31-60c45-21 62-45 51-72-6-14-19-23-37-25s-49 6-91 24c-38 17-62 31-73 45s-14 29-7 44c10 25 37 30 80 17",
    fill: "#005288"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.010781 0 0 -.0108 72 720)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4983,1964)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0 60 200-61 18-19-66-261 78-21-70 261-79-20-63z",
    fill: "#005288"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.010781 0 0 -.0108 72 720)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(5056,2217)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0 13 72-189 34c-27 5-45 9-55 13-10 5-17 11-21 20-4 8-5 18-3 29 2 12 7 21 14 28 7 6 16 9 26 8 10 0 28-2 55-7l189-33 11 61-186 32c-37 7-65 10-84 9s-37-9-53-25c-16-15-27-38-32-68-6-29-5-53 2-71s18-32 34-42 46-19 90-27z",
    fill: "#005288"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.010781 0 0 -.0108 72 720)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(5106,2538)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0 4 105c1 20 1 36-1 47-1 11-6 22-14 34-7 11-18 20-32 27s-30 11-48 12c-42 2-72-13-91-44l-143 68-4-80 131-50-2-37-132 6-3-74zm-52 76-94 4 2 32c1 29 18 43 50 41 11 0 20-3 27-7 7-5 12-10 14-16s3-14 3-25z",
    fill: "#005288"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.010781 0 0 -.0108 72 720)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(5112,2842)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0-16 203-57-5 10-129-78-6-8 101-57-5 8-101-82-6-10 130-60-5 16-203z",
    fill: "#005288"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.010781 0 0 -.0108 72 720)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1303,4299)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0-59-27c14-26 12-47-4-63-7-8-15-12-24-12-9-1-16 2-22 8-7 6-10 14-9 24 1 9 7 25 17 48 9 21 15 39 18 53 3 15 3 29-2 44-4 15-13 29-26 41-22 22-48 32-77 31-29-2-57-16-82-41-42-44-47-93-15-148l58 33c-19 30-18 54 1 74 9 9 19 14 29 15s19-2 27-9c6-6 9-13 10-22 1-8-3-22-12-41-11-25-19-44-22-59-4-14-3-29 1-44 4-16 13-30 25-42 22-21 46-31 73-31 28 1 52 13 75 35 40 42 47 86 20 133",
    fill: "#005288"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.010781 0 0 -.0108 72 720)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1392,4280)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0 158 128-36 44-101-81-49 60 78 64-36 44-78-63-52 64 101 81-38 47-158-128z",
    fill: "#005288"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.010781 0 0 -.0108 72 720)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1602,4693)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0 56 39c-22 30-47 49-76 57-30 9-59 4-88-14-35-22-53-51-55-89-3-37 11-78 39-124s60-76 94-91c35-14 70-10 105 12 59 37 69 94 29 170l-60-31c25-43 25-73 0-88-13-8-28-8-44 1s-36 33-61 72c-21 35-33 61-34 78-1 18 5 31 20 40 22 14 48 3 75-32",
    fill: "#005288"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.010781 0 0 -.0108 72 720)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1808,4566)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0 67 30-78 175c-11 24-18 42-20 53-2 10-1 20 4 28s13 14 23 19c11 5 21 6 30 4 9-3 17-9 22-17 6-8 14-25 25-50l78-174 56 25-76 172c-16 34-29 59-41 74-11 15-28 25-49 30-22 5-47 1-75-12-27-12-46-26-57-41-11-16-16-33-16-52 1-19 10-49 29-89z",
    fill: "#005288"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.010781 0 0 -.0108 72 720)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2071,4679)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0 101 29c20 6 34 11 44 16s19 13 28 24c8 11 13 24 15 40 2 15 1 32-4 49-12 40-35 64-70 71l18 158-77-22-6-140-35-10-37 127-71-21zm55 72-26 90 31 9c28 8 46-3 55-34 3-10 4-20 2-28s-6-14-11-18c-4-4-12-7-22-10z",
    fill: "#005288"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.010781 0 0 -.0108 72 720)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2332,4748)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0 73 14-62 329-72-14z",
    fill: "#005288"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.010781 0 0 -.0108 72 720)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2428,4768)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0 207 21-6 63-68-7-29 270-73-8 29-270-67-7z",
    fill: "#005288"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.010781 0 0 -.0108 72 720)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2640,4791)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0 81-1 48 122 50-123h72l-92 194 2 141-74 1-1-142z",
    fill: "#005288"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.010781 0 0 -.0108 72 720)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3055,4767)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0 73-13 150 314-74 13-28-66-93 16-4 71-67 11zm98 194-56-129-9 140z",
    fill: "#005288"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.010781 0 0 -.0108 72 720)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3399,4847)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0 111-34 53 170-30 10-20-34c-9 33-30 55-65 65-36 12-70 6-100-16s-52-57-67-106c-16-52-19-97-7-134 11-37 37-62 79-75 65-20 113 5 144 76l-60 30c-18-41-39-57-65-49-16 5-26 16-31 35-5 18 0 49 13 92 12 38 25 64 39 76 14 13 30 17 48 11 28-9 36-34 23-76l-48 14z",
    fill: "#005288"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.010781 0 0 -.0108 72 720)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3513,4643)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0 185-85 24 52-118 54 32 71 92-42 24 52-92 42 34 75 119-54 24 54-185 85z",
    fill: "#005288"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.010781 0 0 -.0108 72 720)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3725,4544)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0 69-43 183 131-110-177 49-29 176 284-56 35-214-153 127 206-48 30z",
    fill: "#005288"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.010781 0 0 -.0108 72 720)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4222,4453)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0 55-39c21 29 31 59 30 90-2 31-16 57-42 78-32 26-65 34-101 25-37-10-72-36-106-77-34-42-52-82-55-119s12-69 44-96c54-44 111-35 171 28l-49 46c-33-37-61-47-84-28-11 10-16 24-13 42 4 18 20 45 49 81 26 31 47 51 64 57 16 7 30 5 43-6 21-17 19-44-6-82",
    fill: "#005288"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.010781 0 0 -.0108 72 720)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4135,4250)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0 56-58 121 50-53-121 49-52 75 201 103 98-51 53-102-98z",
    fill: "#005288"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.010781 0 0 -.0108 72 720)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2745,812)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-1068 0-1933 865-1933 1933 0 503 192 960 506 1304l5-64c-300-344-464-779-464-1240 0-504 196-978 552-1334 357-356 830-552 1334-552s978 196 1334 552 552 830 552 1334-196 978-552 1334-830 552-1334 552c-458 0-892-162-1235-460l-34 33c340 295 784 474 1269 474 1068 0 1933-865 1933-1933s-865-1933-1933-1933",
    fill: "#c41230"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.010781 0 0 -.0108 72 720)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(618,3247)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0-47 15c67 283 189 547 353 777l42-27c-162-227-282-486-348-765m4254 0c-66 279-186 538-348 765l42 27c164-230 286-494 353-777z",
    fill: "#0078ae"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.010781 0 0 -.0108 72 720)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(508,3281)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0-48 15c71 295 198 568 368 807l41-27c-167-236-292-505-361-795m4474 0c-69 290-193 559-361 795l41 27c170-239 297-512 368-807z",
    fill: "#0078ae"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.010781 0 0 -.0108 72 720)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(724,3214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0-48 15c65 274 182 527 341 749l41-27c-156-218-272-468-334-737m4042 0c-62 269-177 519-334 737l41 27c159-222 276-475 341-749z",
    fill: "#0078ae"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.010781 0 0 -.0108 72 720)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2981,3457)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0 173 85v135c-197 6-398 52-537 104-62-73-119-150-169-232h115l22-370h107l22 370h82v-92l185 90zm-123 385c-22 0-39 22-39 50v87c26 22 52 43 79 63v-150c0-28-18-50-40-50m172-51c-22 0-40 22-40 50v265c26 17 53 33 80 49v-314c0-28-18-50-40-50m143 419c21 10 42 20 63 29 4-1 8-3 12-5v-968c0-1 1-2 2-2h17c1 0 2 1 2 2v958c24-11 47-23 70-35v-971c0-1 1-2 2-2h17c1 0 2 1 2 2v960c24-13 47-26 70-40v-872c0-1 1-2 2-2h17c1 0 2 1 2 2v859c28-17 56-35 83-54v-960h-361zm610-893-52-1v-73c0-4-1-8-4-12-4-7-11-11-19-11s-15 4-19 11c-2 4-4 8-4 12v74h-52v90h-81v651c118-86 225-185 317-295v-356h-86zm105 423c50-60 95-124 136-191v-63h-136zm-190-1258h-82l41-135zh-82l41-135zm587-260v401c0 41-2 82-5 122h-1845c66-84 102-188 102-296 0-98-30-189-80-266 228-32 530-68 778-70h38c465 0 863 76 1012 109m-1553 219c0-84 24-126 71-126 41 0 62 27 64 82l94-6c-11-100-63-150-156-150-54 0-96 19-127 56s-46 85-46 143c0 62 16 111 48 146s73 53 124 53c42 0 77-12 106-36s46-60 51-106l-87-5c-8 49-31 73-69 73-23 0-41-9-53-26-13-17-20-50-20-98m373-194h-91v386h91zm362 263c0-23-6-43-18-61-13-18-28-31-46-39-19-8-48-16-87-24-23-5-38-10-45-17-7-6-10-14-10-23 0-23 18-35 53-35 34 0 56 15 66 46l77-26c-22-60-70-91-146-91-43 0-76 12-101 36-25 23-38 52-38 87 0 34 11 59 31 77 21 18 56 31 105 42 27 5 45 11 54 17s14 15 14 26c0 12-6 21-16 29s-25 12-46 12c-43 0-69-18-78-54l-84 19c9 36 27 62 55 80s61 27 101 27c52 0 92-12 119-38s40-56 40-90m373 123-121-386h-104l-124 386h79l24-79h125l24 79zm-183-286 41 135h-82zm41 135h-82l41-135zh-82l41-135z",
    fill: "#0078ae"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.010781 0 0 -.0108 72 720)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2714,3233)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0-2-31c24 48 64 87 114 109-2 5-3 9-4 13-45-19-82-51-108-91m442-140c-6-128-111-229-239-229-133 0-241 107-241 240 0 19 3 38 7 56h14c-4-18-7-37-7-56 0-125 102-227 227-227s226 102 226 227c0 92-55 171-134 207 1 4 2 9 4 13 74-32 128-101 141-183v-49h2zm-47 11c0-106-86-193-192-193-107 0-193 87-193 193 0 77 45 144 111 174l4-13c-59-29-101-90-101-161 0-99 80-179 179-179 98 0 178 80 178 179 0 70-41 131-100 160l4 14c65-31 110-97 110-174m-37 0c0-85-70-155-155-155-86 0-155 70-155 155 0 60 34 112 84 138 2-5 3-10 4-15-43-24-73-70-73-123 0-77 62-140 140-140 77 0 140 63 140 140 0 53-30 99-73 123 1 4 3 9 4 14 50-26 84-77 84-137m-31 0c0-69-56-125-124-125-69 0-125 56-125 125 0 46 25 86 63 108l4-15c-31-20-51-54-51-93 0-60 49-109 109-109s109 49 109 109c0 39-20 73-51 92l5 15c36-21 61-61 61-107m-50 0c0-43-33-78-74-78-42 0-75 35-75 78 0 24 10 45 27 60 2-6 3-12 5-18-10-11-16-26-16-42 0-34 26-62 59-62 32 0 59 28 59 62 0 16-6 30-16 41 2 6 4 12 5 18 16-15 26-36 26-59m26 0c0-55-45-100-100-100-56 0-101 45-101 100 0 35 19 66 46 84 2-6 3-11 5-16-21-16-34-40-34-68 0-46 37-84 84-84 46 0 84 38 84 84 0 27-13 51-33 67 2 5 3 11 5 16 26-18 44-48 44-83m760-288h-10c30 90 47 187 47 288 0 67-7 131-21 194h9v8c15-65 22-133 22-202 0-101-16-197-47-288m237 0h-10c24 92 37 188 37 288 0 127-21 249-60 363h10c39-114 60-236 60-363 0-99-13-196-37-288m-430 0h-12c39 88 61 186 61 288 0 101-22 197-59 285h11c12-27 22-55 30-83v-8h2c17-62 27-127 27-194 0-102-22-200-60-288m-1220 430-9 10c28 106 87 201 166 274h17c-84-74-145-172-174-284m1045-430c48 81 76 176 78 277h11c-2-101-29-195-76-277zm-985 0h-13c-10 17-18 34-26 52v30c11-29 24-56 39-82m575 0h-165c-125 36-217 151-217 288 0 19 2 38 6 56h13c-4-18-6-37-6-56 0-158 129-287 287-287 154 0 280 123 286 275h13c-5-131-95-241-217-276m-194 566c1-4 2-9 4-13-34-14-64-34-90-58l1 18c25 22 53 40 85 53m221-13c1 4 2 8 4 12 49-20 92-53 124-95v-22c-31 46-76 83-128 105m21 72c1 4 2 8 4 12 37-15 72-36 103-61v-16c-31 27-67 49-107 65m-322-17c17 11 34 19 53 27v-14c-19-8-37-17-54-28zm-182-320c0 43 7 84 21 122l2-36c-7-28-11-56-11-86 0-117 57-222 144-288h-20c-83 69-136 172-136 288m735-11h12c-3-112-55-211-135-277h-21c85 64 140 164 144 277m-10-277c62 76 100 172 103 277h12c-3-105-40-200-100-277zm-806 288c0-109 39-210 104-288h-16c-62 79-100 179-100 288 0 111 39 212 104 292l1-18c-58-76-93-171-93-274m270 426h28c-10-3-20-7-29-11zm394-23 13 7 15-9v-14c-9 6-18 11-28 16",
    fill: "#5e9732"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCisa);
export default __webpack_public_path__ + "static/media/cisa.cdd7120f65e7b8ffb9f8fd0d76f5978b.svg";
export { ForwardRef as ReactComponent };